module.exports = __webpack_public_path__ + "static/img/footer.06ce929.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/footer.png
// module id = w7J+
// module chunks = 0